'use client';

import { ReactNode } from 'react';
import { usePageContext } from './PageContext';

interface PageContentProps {
  children: ReactNode;
}

const heroBleedStyle = {
  md: '-mt-[136px]',
  none: '',
  sm: '-mt-[77px]',
};

export function PageContent({ children }: PageContentProps) {
  const { heroBleedSize } = usePageContext();

  return (
    <div
      className={`
        ${heroBleedStyle[heroBleedSize]}
        relative
        pb-layout-lg
        px-layout-xs md:px-layout-lg
      `}
    >
      <div
        className="
          mx-auto
          max-w-[744px]
        "
      >
        {children}
      </div>
    </div>
  );
}
